import React from 'react';
import { number, string } from 'prop-types';

const ChevronUp = ({ width, height, viewBox }) => (
  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={width} height={height} viewBox={viewBox}>
    <path id="a" d="M17.47 15.53a.75.75 0 0 0 1.06-1.06l-6-6a.75.75 0 0 0-1.06 0l-6 6a.75.75 0 0 0 1.06 1.06L12 10.06l5.47 5.47z" />
  </svg>
);

ChevronUp.propTypes = {
  width: number,
  height: number,
  viewBox: string,
};

ChevronUp.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
};

export default ChevronUp;
